import React from "react"
import ReactSVG from "react-svg"
import CompleteServiceLogo from "../../../images/rewards/complete-service.svg"

const RewardsServiceCard = ({ service }) => {
  return (
    <div className="rewards-services-card-container">
      <ReactSVG src={CompleteServiceLogo} className="rewards-services-logo" />
      <div className="rewards-service-detail">
        <p className="rewards-service-name">{service.name}</p>
        <p className="rewards-service-label">{service.description}</p>
      </div>
      <p className="reward-service-miles">{service.miles} Miles</p>
    </div>
  )
}

export default RewardsServiceCard
